var _templateObject = _taggedTemplateLiteralLoose(['\n  display: inline-block;\n  width: 10px;\n  height: 10px;\n  cursor: pointer;\n  border-radius: 50%;\n  border: 1px solid white;\n  background-color: ', ';\n\n  &:not(:last-child) {\n    margin-right: 10px;\n  }\n'], ['\n  display: inline-block;\n  width: 10px;\n  height: 10px;\n  cursor: pointer;\n  border-radius: 50%;\n  border: 1px solid white;\n  background-color: ', ';\n\n  &:not(:last-child) {\n    margin-right: 10px;\n  }\n']);

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

import styled from 'styled-components';

export var Dot = styled.li(_templateObject, function (props) {
  return props.isActive ? 'white' : 'transparent';
});